import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";
import darkblueWave from "../../dashboard/svgs/darkblueWave.svg?url";
import violetWave from "../../dashboard/svgs/violetWave.svg?url";
import purpleWave from "../../dashboard/svgs/purpleWave.svg?url";

const violetBackground = "#D9BCFF";

export type RiskReportCardBackground = "darkblue" | "violet" | "purple";

const waves: Record<RiskReportCardBackground, string> = {
    darkblue: darkblueWave,
    violet: violetWave,
    purple: purpleWave,
};

export const useRiskReportCardStyles = (background: RiskReportCardBackground) => {
    const theme = useTheme();
    const isViolet = background === "violet";
    const backgroundColor = isViolet ? violetBackground : background === "purple" ? theme.palette.primary.main : theme.palette.primary.dark;
    return createSxStyles({
        card: {
            height: "100%",
            minHeight: 220,
            borderRadius: "20px",
            padding: theme.spacing(3),
            display: "flex",
            flexDirection: "column",
            color: isViolet ? theme.palette.primary.dark : theme.customPalette.white,
            backgroundColor: backgroundColor,
            backgroundImage: `url("${waves[background]}")`,
            backgroundSize: "100% 55%",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "100% 120%",
        },
        body: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
        },
    });
};
